export default __webpack_public_path__ + "static/media/tironem_background.680e542b.png";